<template>
	<b-overlay
		:show="isLoading"
		rounded="lg"
		opacity="0.6"
		spinner-variant="primary"
	>
		<template #overlay>
			<div class="d-flex align-items-center">
				<b-spinner small type="grow" variant="secondary"></b-spinner>
				<b-spinner type="grow" variant="dark"></b-spinner>
				<b-spinner small type="grow" variant="secondary"></b-spinner>
			</div>
		</template>
		<b-row class="mt-4">
			<b-col cols="12">
				<router-link class="btn btn-sm btn-default" :to="{name: RoleManagePath.name}">
					<em class="fa fa-backward"></em> Manage Roles
				</router-link>
			</b-col>
			<b-col v-if="item">
				<b-form @submit="onSubmit">
					<div class="card mt-4">
						<div class="bg-success p-3">
							<h5 class="card-title mb-0 font-weight-bold">
								Edit Role ({{ this.form.name }})
							</h5>
						</div>
						<div class="card-body">
							<b-row>
								<b-col lg="6" class="mt-4">
									<b-form-group label="Name *">
										<b-form-input
											id="name"
											v-model="form.name"
											type="text"
											step="any"
											placeholder="input name"
											required
										>
										</b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<br />
							<b-row>
								<b-col class="mt-4">
									<b-button variant="primary" type="submit">Update</b-button>
								</b-col>
							</b-row>
						</div>
					</div>
				</b-form>
			</b-col>
		</b-row>
	</b-overlay>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { RoleManagePath } from "../../router/account";

export default {
	name: "editRole",
	data() {
		return {
			RoleManagePath,
			debounce: null,
			form: {
				id: null,
				name: null,
			},
		};
	},
	computed: {
		...mapState({
			isError: (state) => state.accessRole.isError,
			isLoading: (state) => state.accessRole.isLoading,
			errorMessage: (state) => state.accessRole.errorMessage,
			successMessage: (state) => state.accessRole.successMessage,
			item: (state) => state.accessRole.item,
		}),
	},
	watch: {
		errorMessage: function() {
			if (!this.errorMessage) return;
			this.messageAlert("error", this.errorMessage, 5000);
		},
		successMessage: function() {
			if (!this.successMessage) return;
			this.messageAlert("success", this.successMessage);
			Object.assign(this.$data, this.$options.data.call(this));
			this.$router.push(RoleManagePath);
		},
		item: function() {
			if (!this.item) {
				this.messageAlert("error", "not found");
				return;
			}
			if (!Object.keys(this.item).length) return;
			this.setEditRole();
		},
	},
	created() {
		this.form.id = this.$route.params.id;
		this.fetchRoleById(this.form.id);
	},
	methods: {
		...mapActions("accessRole", ["updateRole", "fetchRoleById"]),
		onSubmit(event) {
			event.preventDefault();
			const data = this.form;

      const payload = {
				id: data.id,
				field: {
					name: data.name,
				},
			};

      this.updateRole(payload);
		},
		setEditRole() {
			const data = this.item;
			this.form.id = data?.id;
			this.form.name = data?.name;
			this.form.description = data?.description;
		},
		messageAlert(icon, title, timer = 3000) {
			this.$swal({
				toast: "true",
				position: "top-end",
				icon,
				title,
				showConfirmButton: false,
				timer,
				timerProgressBar: true,
			});
		},
	},
};
</script>
